export default __webpack_public_path__ + "static/Entenda0016-141c66d20f07b8d93440e8b8c1a31d6f.jpg";